import { post } from '@/lib/api';
import type { WholesalerProfile } from './profile';

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  token_type: 'Bearer';
  wholesaler: WholesalerProfile;
}

export interface RegisterInput {
  email: string;
  password: string;
  name: string;
  phone?: string;
  city: string;
}

export const wholesalerRegister = (input: RegisterInput) =>
  post<AuthResponse>('/auth/register', input);

export const wholesalerLogin = (email: string, password: string) =>
  post<AuthResponse>('/auth/login', { email, password });
